require('./lbaSwitch.scss');

const $inject = [];
const lbaSwitch = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaSwitchCtrl',
    controllerAs: 'vm',
    template: require('./lbaSwitch.html')
  }
};

lbaSwitch.$inject = $inject;

export default lbaSwitch;



// WEBPACK FOOTER //
// ./src/components/lbaSwitch/lbaSwitchDir.js